import { render, staticRenderFns } from "./file-pdf.vue?vue&type=template&id=deedb836&scoped=true"
import script from "./file-pdf.vue?vue&type=script&lang=js"
export * from "./file-pdf.vue?vue&type=script&lang=js"
import style0 from "./file-pdf.vue?vue&type=style&index=0&id=deedb836&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deedb836",
  null
  
)

export default component.exports